import React, { PureComponent } from 'react';
import { setLocalStorageItem, getLocalStorageItem } from 'utils/webStorage';
import KeepSessionCheckBox from 'components/Login/KeepSessionCheckBox';
import { localStorageKeys } from 'utils/constants';

export class KeepSession extends PureComponent {
  state = {
    checked: false,
  };

  componentDidMount() {
    const isChecked = getLocalStorageItem(localStorageKeys.keepSession) || false;

    this.setState({ checked: isChecked });
  }

  setChecked(value) {
    this.setState({ checked: value });
    setLocalStorageItem(localStorageKeys.keepSession, value);
  }

  render() {
    const { checked } = this.state;
    return (
      <KeepSessionCheckBox
        isChecked={checked}
        onSelect={isChecked => this.setChecked(isChecked)}
      />
    );
  }
}

export default KeepSession;
